import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost';
  size?: string;
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size: _size,
  className = '', 
  children, 
  disabled,
  ...props 
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-md font-medium transition-colors duration-150 focus-ring disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark active:bg-primary-dark',
    secondary: 'border-2 border-primary text-primary hover:bg-primary hover:text-white active:bg-primary-dark',
    tertiary: 'bg-transparent text-gray-700 hover:bg-gray-100 active:bg-gray-200',
    ghost: 'bg-transparent text-primary hover:bg-gray-50 active:bg-gray-100',
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}

